export function getLocalStorageLastValue(key: string) {
    const lastValueStr = localStorage?.getItem(key);
    const lastValue = typeof lastValueStr === 'string' ? Number(lastValueStr) : undefined;

    return lastValue ?? 0;
}
